var getColDefs = require('./get-col-defs');

module.exports = function (chart, field) {
  var colDefs = getColDefs(chart);

  if (colDefs && colDefs[field]) {
    return colDefs[field];
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/interaction/helper/get-col-def.js
// module id = 378
// module chunks = 0